"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddKnowledgeArguments = exports.AddKnowledgeOptions = void 0;
exports.AddKnowledgeOptions = [
    {
        name: "knowledge-source",
        type: "string",
        description: "Knowledge source.",
        required: true,
        default: "web-search",
        choices: ["web-search", "oneDrive-sharePoint", "graph-connector", "embedded-knowledge"],
    },
    {
        name: "search-type",
        type: "string",
        description: "Select Search Type",
        required: true,
        default: "url",
        choices: ["url", "all-web", "all-oneDrive-sharePoint"],
    },
    {
        name: "web-content",
        type: "string",
        description: "An absolute URL to a site to be searched for content.",
    },
    {
        name: "manifest-file",
        questionName: "manifest-path",
        type: "string",
        shortName: "t",
        description: "Specifies the app manifest file path.",
        required: true,
        default: "./appPackage/manifest.json",
    },
    {
        name: "oneDriveSharePointURL",
        type: "string",
        description: "OneDrive or SharePoint Content",
    },
    {
        name: "oneDriveSharePointContent",
        type: "string",
        description: "OneDrive or SharePoint Content",
    },
    {
        name: "graph-connector-content",
        type: "string",
        description: "Copilot connector Content",
        choices: ["listConnections", "inputConnectionId"],
    },
    {
        name: "graph-connector-list",
        type: "array",
        description: "Select one or more Copilot connectors as capability source",
        default: [],
    },
    {
        name: "graph-connector-input",
        type: "string",
        description: "a connection ID for Copilot connector",
    },
    {
        name: "embedded-knowledge-files",
        type: "array",
        description: "Select your embedded knowledge files.",
    },
];
exports.AddKnowledgeArguments = [];
//# sourceMappingURL=AddKnowledgeOptions.js.map